import React, { Component } from "react";
import PropTypes from "prop-types";
import { Input, PolarQuestion, MultiRadio, ModalInfo } from "shared/components";
import { ValidationService } from "shared/services";
import {
  irregularitiesValidationRules,
  irregularitiesErrorStrings,
} from "shared/validations";
import { omit, pick, isUndefined, isEmpty } from "lodash";
import InputMask from "react-input-mask";
import { withTranslation } from 'react-i18next';
import { SelectRosterExaminee } from "features/irregularities";

import "./ExamineeInfo.scss";

// const setMultiRadioList = (roomDisabled) => {
//   const radioElements = [];
//   radioElements.push({
//     label: this.props.t('irregularities.searchRoomRosterLabel'),
//     key: uniqueId(),
//     value: 'room',
//     name: 'options',
//     disabled: roomDisabled,
//   });
//   radioElements.push({
//     label: this.props.t('irregularities.searchFullRosterLabel'),
//     key: uniqueId(),
//     value: 'full' ,
//     name: 'options',
//   });
//
//   return radioElements;
// };
//
// const mapRegs = regs =>
//   regs.map(reg => ({
//     label: `${reg.firstName} ${reg.lastName}`,
//     value: {
//       firstName: reg.firstName,
//       lastName: reg.lastName,
//       middleName: reg.middleName,
//       matchId: reg.matchId,
//       refRegId: reg.id,
//     }
//   }));

const defaultExaminee = {
  firstName: "",
  lastName: "",
  errors: {},
  matchId: "",
};

class ExamineeInfo extends Component {
  constructor(props) {
    super(props);

    this.state = {
      examinee: props.examinee || Object.assign({}, defaultExaminee),
      selectedExaminee: null,
      examineeNotFoundEnabled: props.examineeNotFoundEnabled,
      searchRosterType: props.roomSelectedFlag ? "room" : "full",
      questions: {
        voidDoc: {
          title: "irregularities.voidDocumentsQuestion",
          initial:
            !props.examinee || isUndefined(props.examinee.voidDocumentFlag)
              ? ""
              : props.examinee.voidDocumentFlag
              ? "Yes"
              : "No",
          key: "voidDocumentFlag",
        },
        examinee: {
          title: "irregularities.examineeNotifiedQuestion",
          initial:
            !props.examinee ||
            !props.examinee.voidDocumentFlag ||
            isUndefined(props.examinee.examineeNotifiedFlag)
              ? ""
              : props.examinee.examineeNotifiedFlag
              ? "Yes"
              : "No",
          key: "examineeNotifiedFlag",
        },
      },
    };

    this.onChange = this.onChange.bind(this);
    this.onChangeId = this.onChangeId.bind(this);
    this.onQuestionChange = this.onQuestionChange.bind(this);
    this.onSelectExaminee = this.onSelectExaminee.bind(this);
    this.toggleExamineeSection = this.toggleExamineeSection.bind(this);
    this.onChangeRosterRegs = this.onChangeRosterRegs.bind(this);
    this.addExaminee = this.addExaminee.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.examineeModalOpen !== prevProps.examineeModalOpen) {
      this.setState({
        examinee: this.props.examinee || Object.assign({}, defaultExaminee),
        examineeNotFoundEnabled: this.props.examineeNotFoundEnabled,
        selectedExaminee:
          this.props.examinee && !isEmpty(this.props.examinee)
            ? {
                label: `${this.props.examinee.lastName}, ${this.props.examinee.firstName}`,
                value: {
                  ...this.props.examinee,
                },
              }
            : null,
        // searchRosterType: this.props.roomSelectedFlag ? 'room' : 'full',
        questions: {
          voidDoc: {
            title: "irregularities.voidDocumentsQuestion",
            initial:
              !this.props.examinee ||
              isUndefined(this.props.examinee.voidDocumentFlag)
                ? ""
                : this.props.examinee.voidDocumentFlag
                ? "Yes"
                : "No",
            key: "voidDocumentFlag",
          },
          examinee: {
            title: "irregularities.examineeNotifiedQuestion",
            initial:
              !this.props.examinee ||
              !this.props.examinee.voidDocumentFlag ||
              isUndefined(this.props.examinee.examineeNotifiedFlag)
                ? ""
                : this.props.examinee.examineeNotifiedFlag
                ? "Yes"
                : "No",
            key: "examineeNotifiedFlag",
          },
        },
      });
    }
  }

  onQuestionChange(question, option) {
    let examinee = { ...this.state.examinee };
    examinee[question.key] = option === "No" ? !option : !!option;
    examinee.errors[question.key] = "";

    if (question.key === "voidDocumentFlag") {
      examinee = omit(examinee, ["examineeNotifiedFlag"]);
      examinee.errors.examineeNotifiedFlag = "";
    }

    this.setState({
      examinee,
    });
  }

  onChange(e) {
    const { name, value } = e.target;

    if (!ValidationService.name(value)) {
      this.setState((prevState) => ({
        examinee: {
          ...prevState.examinee,
          errors: {
            ...prevState.examinee.errors,
            [name]: ["errors.specialCharactersNotAllowed"],
          },
        },
      }));
      return;
    }

    this.setState((prevState) => ({
      examinee: {
        ...prevState.examinee,
        [name]: value,
        errors: {
          ...prevState.examinee.errors,
          [name]: "",
        },
      },
    }));
  }

  onChangeId(e) {
    const { name, value } = e.target;
    let examinee = { ...this.state.examinee };
    examinee.errors[name] = "";

    this.setState((prevState) => ({
      examinee: {
        ...prevState.examinee,
        [name]: value,
      },
    }));
  }

  onSelectExaminee(selected) {
    this.setState((prevState) => ({
      selectedExaminee: selected,
      examinee: selected
        ? {
            ...prevState.examinee,
            ...selected.value,
            errors: {
              ...prevState.examinee.errors,
              selectedExaminee: "",
            },
          }
        : prevState.examinee,
    }));
  }

  toggleExamineeSection() {
    this.setState((prevState) => ({
      examineeNotFoundEnabled: !prevState.examineeNotFoundEnabled,
      examinee: {
        ...defaultExaminee,
        idGenerated: prevState.examinee.idGenerated,
      },
      selectedExaminee: null,
    }));
  }

  onChangeRosterRegs(e) {
    this.setState({
      searchRosterType: e.target.value,
    });
  }

  addExaminee() {
    const { allowVoidFlag, hideMatchIdFlag } = this.props;
    const { examineeNotFoundEnabled, selectedExaminee } = this.state;
    let updatedExaminee = { ...this.state.examinee };
    let errors = {};

    if (examineeNotFoundEnabled) {
      if (hideMatchIdFlag) {
        const fields = pick(updatedExaminee, ["lastName", "firstName"]);
        errors = ValidationService.validate(
          fields,
          irregularitiesValidationRules,
          irregularitiesErrorStrings
        );
      } else {
        const fields = pick(updatedExaminee, [
          "lastName",
          "firstName",
          "matchId",
        ]);
        errors = ValidationService.validate(
          fields,
          irregularitiesValidationRules,
          irregularitiesErrorStrings
        );

        if (!updatedExaminee.matchId) {
          errors.matchId = ["errors.matchIdRequired"];
        }

        if (updatedExaminee.matchId.includes("_")) {
          errors.matchId = ["errors.matchIdLimit"];
        }
      }
    } else if (!selectedExaminee) {
      errors.selectedExaminee = ["errors.selectExamineeRequired"];
    }

    if (allowVoidFlag) {
      if (isUndefined(updatedExaminee.voidDocumentFlag)) {
        errors.voidDocumentFlag = ["errors.voidDocumentRequired"];
      }
      if (
        updatedExaminee.voidDocumentFlag &&
        isUndefined(updatedExaminee.examineeNotifiedFlag)
      ) {
        errors.examineeNotifiedFlag = ["errors.answerRequired"];
      }
    } else {
      updatedExaminee.examineeNotifiedFlag = false;
      updatedExaminee.voidDocumentFlag = false;
    }

    if (!isEmpty(errors)) {
      this.setState((prevState) => ({
        examinee: {
          ...prevState.examinee,
          errors,
        },
      }));
      return;
    }

    this.props.onAddExaminee(updatedExaminee);
  }

  render() {
    const {
      examinee,
      questions,
      examineeNotFoundEnabled,
      searchRosterType,
      selectedExaminee,
    } = this.state;
    const {
      roomRegsOptions,
      eventRegsOptions,
      roomSelectedFlag,
      editFlag,
      examineeModalOpen,
      disabledRoomRosters,
      hideMatchIdFlag,
    } = this.props;

    const examineeOptions =
      searchRosterType === "room" ? roomRegsOptions : eventRegsOptions;
    const modalTitle = editFlag
      ? "irregularities.editExaminee"
      : "irregularities.addNewExamineeLabel";
    const buttonLabel = editFlag
      ? "irregularities.saveExaminee"
      : "irregularities.addExamineeLabel";

    return (
      <ModalInfo
        className="modal-examinee"
        modalIsOpen={examineeModalOpen}
        closeModal={() => this.props.toggleModal()}
        onSubmit={this.addExaminee}
        headerTitle={modalTitle}
        saveLabel={buttonLabel}
      >
        <section key={this.props.order} className="examinee-info pt-2">
          {examineeNotFoundEnabled ? (
            <div className={`${hideMatchIdFlag ? "pt-5" : ""}`}>
              <div className="name-content name-form-container pb-3">
                <Input
                  type="text"
                  name="lastName"
                  label="irregularities.examineeLastNameLabel"
                  value={examinee.lastName}
                  onChange={this.onChange}
                  errors={examinee.errors.lastName}
                  required
                />
                <Input
                  type="text"
                  name="firstName"
                  label="irregularities.examineeFirstNameLabel"
                  value={examinee.firstName}
                  onChange={this.onChange}
                  errors={examinee.errors.firstName}
                  required
                />
              </div>
              {!hideMatchIdFlag && (
                <div>
                  <label
                    htmlFor="matchId"
                    className={`${
                      examinee.errors && examinee.errors.matchId
                        ? "label-error"
                        : ""
                    } fw-bold d-block`}
                  >
                    {this.props.t("irregularities.matchIDLabel")}
                  </label>
                  <InputMask
                    className={`input-mask ${
                      examinee.errors && examinee.errors.matchId ? "error" : ""
                    }`}
                    name="matchId"
                    id="matchId"
                    mask="09999-99999"
                    value={examinee.matchId}
                    maskChar="_"
                    placeholder="0XXXX-XXXXX"
                    onChange={this.onChangeId}
                  />
                  {!examinee.errors.matchId && (
                    <p className="font-size-12 dark-gray">
                      {this.props.t("common.labels.onlyNumbersAccepted")}
                    </p>
                  )}
                  {examinee.errors.matchId &&
                    examinee.errors.matchId.map((error) => (
                      <p className="text-error font-size-12" key={error}>
                        {this.props.t(error)}
                      </p>
                    ))}
                </div>
              )}
            </div>
          ) : (
            <React.Fragment>
              <SelectRosterExaminee
                selectedExaminee={selectedExaminee}
                onSelectExaminee={this.onSelectExaminee}
                disabledRoomRosters={disabledRoomRosters}
                errors={examinee.errors}
                roomRegsOptions={roomRegsOptions}
                eventRegsOptions={eventRegsOptions}
                roomSelectedFlag={roomSelectedFlag}
                hideMatchIdFlag={hideMatchIdFlag}
                selectLabel="irregularities.examineeFullNameLabel"
                selectPlaceholder="irregularities.selectExaminee"
                matchIdMessage="irregularities.matchIdInfoText"
              />
            </React.Fragment>
          )}
          {!hideMatchIdFlag && (
            <Input
              containerClassName="roster-check pt-3"
              type="checkbox"
              name="examineeCheck"
              id="examineeCheck"
              checked={examineeNotFoundEnabled}
              onChange={this.toggleExamineeSection}
              infoText={this.props.t("irregularities.examineeNotFoundInfoText")}
            >
              <label htmlFor="examineeCheck">
                {this.props.t("irregularities.examineeNotFoundLabel")}
              </label>
            </Input>
          )}
          {this.props.allowVoidFlag && (
            <div className="border-top-gray pt-4 mt-3">
              <PolarQuestion
                question={questions.voidDoc}
                value={
                  !examinee || isUndefined(examinee.voidDocumentFlag)
                    ? ""
                    : examinee.voidDocumentFlag
                    ? "Yes"
                    : "No"
                }
                onChange={this.onQuestionChange}
                errors={examinee.errors.voidDocumentFlag}
              />
              <PolarQuestion
                question={questions.examinee}
                value={
                  !examinee ||
                  !examinee.voidDocumentFlag ||
                  isUndefined(examinee.examineeNotifiedFlag)
                    ? ""
                    : examinee.examineeNotifiedFlag
                    ? "Yes"
                    : "No"
                }
                onChange={this.onQuestionChange}
                disabled={!examinee.voidDocumentFlag}
                errors={examinee.errors.examineeNotifiedFlag}
              />
            </div>
          )}
        </section>
      </ModalInfo>
    );
  }
}

export default withTranslation()(ExamineeInfo);